


























import { Component, Prop, Vue } from "vue-property-decorator";

import GreenUnderlineText from "@/components/common/text/GreenUnderlineText.vue";
import ServiceItem from "@/components/service/ServiceItem.vue";
import ServiceSummaryItem from "@/components/service/ServiceSummaryItem.vue";
import { ServiceGroupInterface } from "@/interfaces/service-group.interface";
import { ServiceMenuInterface } from "@/interfaces/service-menu.interface";

@Component({
  components: {
    GreenUnderlineText,
    ServiceSummaryItem,
    ServiceItem,
  },
})
export default class ServiceGroupItem extends Vue {
  @Prop({ required: true }) private item!: ServiceGroupInterface;
  @Prop({ required: false }) private summary!: boolean;

  private onClickSummary(service: ServiceSummaryItem): void {
    this.$emit("click-summary", service);
  }

  private onClickServiceMenu(serviceMenu: ServiceMenuInterface): void {
    this.$emit("click-service-menu", serviceMenu);
  }
}
